export default __webpack_public_path__ + "static/media/CDR_placeholder.1d8263e5.svg";